<form [formGroup]="cartForm"
  #form="ngForm"
  *ngrxLet="cart$ as cart"
  class="cart-page flex-column justify-start align-stretch"
  [ngClass]="{ 'cart-page-disabled': (isLoading$ | async) }">

  <mat-toolbar class="cart-header-toolbar">
    <mat-toolbar-row class="flex-row justify-center align-center">
      <div>
        <!-- button retour-->
        <app-back-button [style]="{ padding: 0 }"
          [stopNavigation]="sideViewMode"
        (goBack)="sideViewMode && onClose()"></app-back-button>
      </div>
      <div class="cart-page-title"> {{ "CART.TITLE" | transloco }} </div>
      @if (cart && (cart.products?.length > 0 || cart.deliveryDate)) {
        <app-cart-clear-button
        (clearCart)="onClearCart(cart)"></app-cart-clear-button>
      }
      @if ((isSubmittingOrReviewinData$ | async)) {
        <mat-progress-bar class="cart-page-title-loadingbar"
          mode="query"
        ></mat-progress-bar>
      }
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="cart-container"
    >
    @switch (cartState$ | async) {
      @case ('LOADING') {
        <div
          class="cart-loading-template">
          @for (i of [1, 2, 3]; track i) {
            <content-loader
              [viewBox]="null"
              [style]="{ width: '100%', height: '60px' }">
              <svg:circle cx="15" cy="15" r="8" />
              <svg:rect x="40" y="0" rx="3" ry="3" width="60%" height="12" />
              <svg:rect x="40" y="22" rx="3" ry="3" width="40%" height="10" />
            </content-loader>
          }
        </div>
      }
      @case ('EMPTY') {
        <div
          class="cart-empty flex-column justify-center align-center">
          <div class="cart-title"> {{ "CART.EMPTY" | transloco }} </div>
          <div>
            <button class="full-width"
              mat-flat-button
              color="primary"
            (click)="navigateToMenu()">{{ "CART.ADD_PRODUCTS" | transloco }}</button>
          </div>
        </div>
      }
      @case ('VISIBLE') {
        <div [formGroup]="cartForm"
          >
          <ng-container *ngrxLet="menu$ as menu">
            <!--Produits-->
            <app-cart-product-list [cartProductList]="cart.products"
              [filter]="nonCutleryNorReturnableContainerProductfilter"
              [currencyCode]="currencyCode$ | async"
              (editCartProductClick)="openProductEdit($event)"
              [isReadOnly]="(canEdit$ | async)===false"
            [showCategory]="true"></app-cart-product-list>
            <!--Cutlery-->
            @if (showCutlery) {
              <app-cart-cutlery
                [cartProductsList]="cart.products"
                [currencyCode]="currencyCode$ | async"
                (editCartProductClick)="openProductEdit($event)"
                [isReadOnly]="(canEdit$ | async)===false"
                (addCutleryProducts)="onAddCutleryProducts()"
                (removeCutleryProducts)="onRemoveCutleryProducts()"
              [mealCount]="mealCount"></app-cart-cutlery>
            }
            <!--Returnable containers-->
            @if (showReturnableProductContainers) {
              <app-cart-returnable-container
                [cartProductsList]="cart.products"
              [currencyCode]="currencyCode$ | async"></app-cart-returnable-container>
            }
            <!--Total-->
            <app-cart-product-total [totalPrice]="cart.totalPrice"
              [totalVatPrice]="cart.totalVatPrice"
              [cartProductList]="cart.products"
              [discounts]="cart.discounts"
              [fees]="cart.fees"
              [currencyCode]="currencyCode$ | async"
            [showVAT]="showVAT$ | async"></app-cart-product-total>
            <mat-divider class="cart-divider"></mat-divider>
            <!--Ma commande-->
            <div class="cart-delivery">
              <div class="cart-delivery-title"> {{ "CART.DELIVERY_TITLE" | transloco }}</div>
              <div class="cart-delivery-content flex-column justify-start align-stretch">
                @if (isTableServiceEnabled$ | async) {
                  <!-- Table prompt Date -->
                  <app-order-preparation-destination-input [preparationSettings]="menu.consumptionMode.orderPreparationSettings"
                    formControlName="destination"
                    (destinationChange)="onDestinationChange($event)"
                    [readonly]="(canEdit$ | async)===false"
                    [headerPrompt]="null"
                  class="cart-delivery-destination-prompt"></app-order-preparation-destination-input>
                }
                <!-- Place -->
                <app-place-selector (placeEditEvent)="onPlaceChanged($event)"
                [isReadOnly]="(canEdit$ | async) === false || (isEmbedded$ | async) === true"></app-place-selector>
                <!-- Consumption Mode -->
                @if (menu.consumptionMode.displayConsumptionModes) {
                  <app-cart-consumption-mode [consumptionMode]="cart.consumptionMode || menu.consumptionMode?.type"
                    [consumptionModes]="menu.restaurant.consumptionModes"
                    (consumptionModeChange)="onConsumptionModeChange($event)"
                    [readonly]="(canEdit$ | async)===false"
                  ></app-cart-consumption-mode>
                }
                @if (menu.consumptionMode.displayPickupScheduleInput) {
                  <mat-divider class="command-divider"></mat-divider>
                  <!-- Delivery Date -->
                  @if (menu.consumptionMode.pickupSchedulePrompt) {
                    <div
                    class="cart-delivery-schedule-prompt">{{ menu.consumptionMode.pickupSchedulePrompt }}</div>
                  }
                  <app-delivery-date-selector formControlName="deliveryDate"
                    [deliveryDate]="deliveryDate$ | async"
                    (deliveryDateChange)="onDeliveryDateChange($event)"
                    [promptMessageWhenEmpty]="(menu.consumptionMode.pickupSchedulePrompt) ? 'CART.DELIVERY_DATE_TIME_TITLE_ALTERNATIVE' : 'CART.DELIVERY_DATE_TIME_TITLE'"
                    [isReadOnly]="(canEditDeliveryDate$ | async)===false"
                  [isRequired]="menu.consumptionMode.displayPickupScheduleInput"></app-delivery-date-selector>
                  @if (cartForm.get('deliveryDate').touched && cartForm.get('deliveryDate').errors; as errors) {
                    <mat-divider class="command-divider command-divider-error"></mat-divider>
                    <div class="cart-delivery-errors"
                      @errorInOutAnimation>
                      @if (errors['required']) {
                        <mat-error>{{ errors['required'] }}</mat-error>
                      }
                    </div>
                  } @else {
                    <mat-divider class="command-divider"></mat-divider>
                  }
                }
              </div>
            </div>
            <!--Livraison-->
            @if (isDeliveryEnabled$ | async) {
              <div class="cart-delivery-location"
                >
                <div class="cart-delivery-location-title"> {{ "CART.DELIVERY_LOCATION_TITLE" | transloco }}</div>
                <!-- Address -->
                <div class="cart-delivery-location-content flex-column justify-start align-stretch">
                  <app-cart-delivery-location formControlName="deliveryAddress"
                    [readonly]="(canEdit$ | async)===false"
                  (addressChanged)="onDeliveryAddressChange($event)"></app-cart-delivery-location>
                  <!-- Phone -->
                  <!-- TODO Delivery Phone... -->
                </div>
              </div>
            }
            @if (enablePromocodeInput$ | async) {
              <app-cart-promocode
                [readonly]="(canEdit$ | async)===false"
                [isLoading]="isSubmittingOrReviewinData$ | async"
                [appliedPromocode]="appliedPromocode"
                [promocodeError]="promocodeError"
                (applyPromocode)="onAppyPromocode($event)"
                (removePromocode)="onRemovePromocode()"
              #promocodeInput></app-cart-promocode>
            }
            <!--Comment / prompt-->
            <app-cart-prompt formControlName="comment"
              [choices]="menu.consumptionMode.customerPromptChoices"
              [choiceItems]="menu.consumptionMode.customerPromptChoiceItems"
              [choicesDisplayMode]="menu.consumptionMode.customerPromptChoicesDisplayMode"
              [allowedChoices]="allowedChoices$ | async"
              [choicesMandatory]="choicesMandatory$ | async"
              [displayComment]="menu.consumptionMode.enableComment"
              [comment]="cart.comment"
              (commentChange)="onCommentChange($event)"
              [commentTitle]="menu.consumptionMode.additionalInformationTitle"
              [commentMandatory]="menu.consumptionMode.isCommentRequired"
            [readonly]="(canEdit$ | async)===false"></app-cart-prompt>
            <!--Paiement-->
            @if (showPayments$ | async) {
              <app-cart-payment formControlName="payment"
                [selectedPaymentMethod]="cart.payment"
                (selectedPaymentMethodChange)="onPaymentSelected($event)"
                [readonly]="(canEditPayment$ | async)===false"
              ></app-cart-payment>
            }
          </ng-container>
        </div>
      }
      @case ('ORDERING_CLOSED') {
        <div
          class="cart-ordering-closed">
          <mat-icon class="cart-ordering-closed-icon">disabled_by_default</mat-icon>
          @if ((closingMessage$ | async); as closingMessage) {
            <div class="cart-title"
            > {{ closingMessage.message }} </div>
          }
        </div>
      }
    }
  </div>
  @if ((cartState$ | async) === 'VISIBLE') {
    <mat-toolbar class="cart-footer-toolbar"
      [ngClass]="{ 'cart-footer-toolbar-embedded': (isEmbedded$ | async) }"
      class="cart-footer-toolbar flex-column justify-center align-center"
      >
      <!-- Validation summary -->
      <!-- <div *ngIf="form.invalid">
      <mat-error *ngIf="cartForm.get('payment').hasError('required') && form.submitted">
        {{ cartForm.get('payment').getError('required') }}
      </mat-error>
    </div> -->
    <!--Confirmation-->
    <app-cart-confirm [cartConfirmForm]="cartForm"
      [total]="(cart$ | async).totalPrice"
      (confirmCart)="confirmCart()"
      [inProgress]="(canSubmit$ | async)===false"
    [currencyCode]="currencyCode$ | async"></app-cart-confirm>
  </mat-toolbar>
}

</form>
